export enum TractionType {
  Tram = "Tram",
  Trolleybus = "Trolleybus",
  Bus = "Bus"
}

export enum DayOfWeek {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday"
}

export interface Paint {
  vehicleId: string;
  paintId: string;
  name: string;
}

export interface Model {
  name: string;
  registrationNumbers: number[];
  tractionType: TractionType;
}

export interface CachedSnapshot {
  age: number;
  date: Date;
  dayOfWeek: DayOfWeek;
  isOld: boolean;
  vehicles: Vehicle[];
}

export interface Vehicle {
  id: string;
  registrationNumber: number;
  tractionType: TractionType;
  lineMeta: LineMeta;
  connectionId?: number;
  delayMinutes: number;
  lastStopIndex?: number;
  lastStopName?: string;
  nextStopIndex?: number;
  nextStopName?: string;
  startName?: string;
  destinationName?: string;
  isAirConditioned: boolean;
  order?: number;
  lastPhotoId?: number;
  lastPhotoAge?: number;

  // Special import system
  isImported?: boolean;
}

export interface LineMeta {
  name: string;
  tractionType: TractionType;
}

export interface ListPair {
  model: Model;
  vehicles: Vehicle[];
}

export interface Trip {
  id: number;
  line: string;
  departures: Departure[];
}

export interface Departure {
  stopName: string;
  departuresAt: string; //TimeSpan hh:mm:ss
  isOnRequest: boolean;
}

export interface Course {
  originalLine: string;
  order: number;
}

export enum ShiftType {
  Morning = "Morning",
  FullDay = "FullDay",
  Split = "Split",
  Afternoon = "Afternoon",
  Night = "Night"
}

export interface Shift {
  endsAt?: string;
  type: ShiftType;
}

export interface PhotoMeta {
  author: string;
  age: number;
}
